/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { match as Match } from 'react-router-dom';

import LoadingIndicator from './uiold/LoadingIndicator';
import { Page, Separator } from './uiold';
import connectData, { ConnectedProps } from '../support/connectData';

import ProfileCard from './Vendor/ProfileCard';
import { canUser } from '../support/shared/permissionHelpers';
import { useParams } from './Navigation';

type RouteParams = { id: string };

type Props = {
  match: Match<RouteParams>;
};

function VendorChangeDetails(props: FullProps) {
  const {
    isLoading,
    vendor,
    formDef,
    account,
    markets,
    vendorsSummary,
    user,
  } = props;
  const params = useParams();

  let vendorSummary = vendorsSummary?.list.find(
    (vendor) => vendor.id === params.id,
  );

  let canEdit = user && canUser(user, { vendors: 'WRITE' });

  let pageTitle = 'Vendor Change Request';
  if (
    isLoading ||
    !vendor ||
    !account ||
    !markets ||
    (markets && !markets?.list) ||
    !vendorSummary ||
    !formDef
  ) {
    return (
      <Page>
        <Page.Header title={pageTitle} showSeparator={false} />
        <Separator />
        <LoadingIndicator />
      </Page>
    );
  }

  return (
    <Page>
      <Page.Header title={pageTitle} showSeparator={false} />
      <ProfileCard
        formDef={formDef as any}
        vendor={vendor}
        account={account}
        isMarketOwner={true}
        markets={markets.getList()}
        canEdit={canEdit}
      />
    </Page>
  );
}

const connector = connectData<Props>()((props) => ({
  vendor: {
    dataStoreKey: 'vendors/:id',
    params: [props.match.params.id],
  },
  markets: { dataStoreKey: 'markets' },
  user: { dataStoreKey: 'user' },
  vendorsSummary: { dataStoreKey: 'vendors/withMarket' },
  account: { dataStoreKey: 'account' },
  formDef: {
    dataStoreKey: 'forms/:id',
    params: ['signup'],
  },
}));
type FullProps = ConnectedProps<typeof connector>;
export default connector(VendorChangeDetails);
